import { ComponentPropsWithRef } from 'react'
import styled from 'styled-components'

import { Flex } from '../../new/core-components/box'
import { Tooltip } from '../tooltip'

export const PillContainer = styled(Flex)<
  ComponentPropsWithRef<typeof Flex> & { isUnderEdit?: boolean }
>`
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover,
  &:focus {
    background: ${props =>
      props.theme.colors[props.isUnderEdit ? 'transparent' : 'bg/list-item-hover']};
    outline: none;
  }
`

export const StyledTooltip = styled(Tooltip)`
  width: 100%;
  overflow: hidden;
`
